import React from "react";
import { COLOUR } from "../__constants__";
import usePluginsApi from "../__hooks__/usePlugins";
import Field from "../components/Field";
import FileName from "../components/FileName";
import moment from "moment";
import { DownloadPluginHeader } from "./__styles__";
import { PLATFORM } from "../config.js";
import { SETTINGS } from "../config.js";

const FONT_STYLE_TITLE = {
  fontFamily: "Poppins",
  fontSize: 20,
  fontWeight: 700,
  letterSpacing: "0em",
  textAlign: "left",
};

function formatBytes(bytes, decimals = 2) {
  if (!+bytes) return "0 Bytes";

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["Bytes", "Kb", "Mb", "Gb", "Tb", "Pb", "Eb", "Zb", "Yb"];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
}

export default function Download({ manifest = {}, releasePath = "" }) {
  let fileTitle = "";

  if (manifest && manifest.filename) {
    fileTitle = manifest.filename;

    const splited = manifest.filename.split("/");

    if (splited.length > 0) {
      fileTitle = splited[1];
    }
  }

  return (
    <div
      style={{
        width: "100%",
        maxHeight: 194,
        border: `1px solid ${COLOUR.PLUGIN_HEADERS_COLOUR}`,
        borderRadius: 8,
        backgroundColor: "white",
        overflow: "hidden",
        marginBottom: 32,
        flex: "1 0 auto",
      }}
    >
      <DownloadPluginHeader>
        {manifest?.resources?.en?.revitsupport || ""}
      </DownloadPluginHeader>
      <div style={{ margin: 24, display: "flex", flexDirection: "column" }}>
        <div
          style={{
            height: 80,
            borderBottom: `1px solid ${COLOUR.BODY_BACKGROUND}`,
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              maring: "16px 16px 0px 16px",
              height: "100%",
            }}
          >
            <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
              <Field title="Version:" value={manifest?.version} />
              <Field
                title="Published:"
                value={moment(Number(manifest?.posteddate)).format(
                  "DD/MM/YYYY"
                )}
              />
            </div>
            <div style={{ flex: 1 }}>
              <Field
                title="OS Support:"
                value={manifest?.resources?.en?.ossupport}
              />
              <Field
                title="File size:"
                value={formatBytes(manifest?.filesize)}
              />
            </div>
          </div>
        </div>
        <div style={{ height: 40 }}>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              margin: 8,
              height: "100%",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <FileName
              url={`${SETTINGS[PLATFORM].REACT_APP_BASE_URL}/${releasePath}/${manifest?.filename}`}
              title={fileTitle}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
